import type { AxiosError, GlobalCustomerRegistrationsRegistrationDto } from '@ori/global-api-client-react';
import { getCustomerRegistration, HttpStatusCodes, useApiClient } from '@ori/global-api-client-react';
import { useEffect, useState } from 'react';

import { useConfiguration, useNotificationData } from '../../../contexts';
import { useTranslations } from '../../../hooks/useTranslations_simplified-registration-BrandPartner';
import { MessageType } from '../../../interfaces';
import { FetchResult } from '../../FetchResult';
import { TranslationKey } from '../../TranslationKey_simplified-registration-BrandPartner';

// this api not calling with swr, because we have some problem with cache
export const useRegistrationData = (reFetchkey?: string) => {
  const [registrationData, setRegistrationData] = useState<GlobalCustomerRegistrationsRegistrationDto>();

  const { tenant, registrationId, registrationType } = useConfiguration();
  const api = useApiClient();
  const { formatMessage } = useTranslations();
  const {
    context: { notificationData },
  } = useNotificationData();
  const { setNotificationData } = notificationData;

  const navigateConsultantUrl = `/join-us/self-registration`;
  const navigateVipUrl = `/join-us/self-vip-registration`;

  const errorMeesage = formatMessage(TranslationKey.cannotGetData);

  useEffect(() => {
    const getData = async () => {
      if (registrationId) {
        try {
          const getResponse = await getCustomerRegistration(api, registrationId);
          const result = new FetchResult<unknown>(getResponse.status);

          if (result.isSuccess()) {
            setRegistrationData(getResponse.data);
          }
        } catch (error: unknown) {
          const errorResponse = error as AxiosError;
          const statusNotFound = errorResponse.response?.status === HttpStatusCodes.status404NotFound;

          setNotificationData({
            isOpen: true,
            message: errorMeesage,
            type: MessageType.error,
            messageId: 'cannotGetData',
          });

          if (statusNotFound) {
            window.location.href = registrationType === 'VipCustomer' ? navigateVipUrl : navigateConsultantUrl;
          }
        }
      }
    };
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps --- not needed updated on other property
  }, [tenant, registrationId, reFetchkey]);

  return { data: registrationData };
};
